import React from 'react'
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import Card from 'react-bootstrap/Card';

import asset from '../images/asset-management.jpeg';
import legend from '../images/home/newLegend.jpeg';
import consulting from '../images/home/18_1108431911.jpg';
import engService from '../images/home/19_2114019077.jpg';
import field from '../images/home/20_2158048149.jpg';
import supply from '../images/home/21_2151657351.jpg';
import operation from '../images/home/22_660549931.jpg';
import epc from '../images/home/23_398992222.jpg';

import '../styles/mainItem.css'

const AssetManagement = () => {

    const handleScrollToTop = () => {
        // Smooth scroll to the top of the page
        window.scrollTo(0, 0)
    };

    return (
        <div className='main-page'>
            <Image src={legend} fluid className="mainItemPage-img" />
            <div className='sub-items'>
                <Container>
                    <h1 className='mb-4'>Services</h1>
                    <hr className='mb-4' />
                    <Row className='justify-content-md-start'>
                        <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                            <Card className='sub-items-card' as={Link} to="/consulting" onClick={handleScrollToTop}>
                                <Card.Body>
                                    <p>Consulting</p>
                                    <div className='card-image-frame'>
                                        <Image src={consulting} rounded className='exec-summary-images2' />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                            <Card className='sub-items-card' as={Link} to="/engineering-design" onClick={handleScrollToTop}>
                                <Card.Body>
                                    <p>Engineering Services</p>
                                    <div className='card-image-frame'>
                                        <Image src={engService} rounded className='exec-summary-images2' />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                            <Card className='sub-items-card' as={Link} to="/field-services" onClick={handleScrollToTop}>
                                <Card.Body>
                                    <p>Field Services</p>
                                    <div className='card-image-frame'>
                                        <Image src={field} rounded className='exec-summary-images2' />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                            <Card className='sub-items-card' as={Link} to="/supply-chain-services" onClick={handleScrollToTop}>
                                <Card.Body>
                                    <p>Supply Chain Services</p>
                                    <div className='card-image-frame'>
                                        <Image src={supply} rounded className='exec-summary-images2' />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                            <Card className='sub-items-card' as={Link} to="/operation-maintenance-services" onClick={handleScrollToTop}>
                                <Card.Body>
                                    <p>Operations & Maintenance Services</p>
                                    <div className='card-image-frame'>
                                        <Image src={operation} rounded className='exec-summary-images2' />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                            <Card className='sub-items-card' as={Link} to="/epc-services" onClick={handleScrollToTop}>
                                <Card.Body>
                                    <p>EPC Services</p>
                                    <div className='card-image-frame'>
                                        <Image src={epc} rounded className='exec-summary-images2' />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default AssetManagement